module.exports = {
    "page.im.setting.btn.clear": "Hapus Terpilih",
    "page.im.window.sessionFilterPlaceholder": "Pencarian nama pelanggan...",
    "im.messageList.unpaidOrderItemTip": "Total Item",
    "page.im.window.label.emptyList": "Oh tidak, apa pun yang pembeli belum dibeli dari toko anda belum.",
    "page.im.setting.init.confirm": "Ketika akun Chat Utama sudah dipilih, maka akun tersebut tidak bisa di edit maupun di hapus. Pastikan anda telah memasukkan akun yang tepat.",
    "page.import.importBox.importModeText": "Jenis Impor",
    "page.im.setting.imForm.to": "Hingga",
    "page.im.window.filter.all": "Semua",
    "im.messageList.change": "Ubah",
    "page.im.window.tab.collectiveVoucher": "Vocer Kolektif",
    "lazada_im_sticker_no": "TIDAK",
    "page.import.historyBox.col.action": "Proses",
    "im.messageList.failedStatus": "Pesan gagal terkirim. {resend} atau {delete}",
    "im.messageList.payNow": "Bayar Sekarang",
    "page.im.window.voucher.sendBatch.creatingDesc": "Voucher belum terkirim mohon untuk tidak menutup halaman ini. Klik Simpan apabila kamu telah membuat voucher di halaman baru.",
    "page.im.window.label.status": "Status",
    "im.messageList.status": "Status",
    "page.import.importBox.templateTitle": "Unduh Template",
    "im.messageList.orderNumber": "Nomor Pesanan",
    "page.import.historyBox.feedback.failed": "Impor Anda gagal",
    "page.import.historyBox.col.status": "Status",
    "page.import.importBox.footerTips": "Deskripsi produk yang diperbarui dengan menggunakan metode Upload Massal (Mass Upload) tidak akan terlihat di Lorikeet. Silahkan mengunduh konten produk dalam bentuk CSV dengan cara klik Ekspor pada halaman Kelola Produk. Kemudian, lihat pada kolom 'description'",
    "page.im.window.label.shopSku": "Shop SKU",
    "page.import.footer.button.done": "Selesai",
    "page.im.window.date.yesterday": "kemarin",
    "page.im.window.voucher.sendBatch.submitSuccess": "Voucher khusus follower akan terkirim dalam beberapa menit.",
    "im.messageList.followBtn": "Ikuti",
    "page.import.importBox.infos.1": "Untuk membuat atau mengunggah produk, Anda dapat menggunaan file CSV (.csv) atau file Excel (.xlsx)",
    "page.import.historyBox.col.processed": "Processed",
    "page.im.window.app.download": "Buka Chat via aplikasi untuk pengalaman terbaik",
    "page.im.window.discount.cashLabelPrefixLine1": "Nilai",
    "page.im.setting.btn.createUser": "Buat Pengguna Akses Penuh Baru",
    "lazada_im_sticker_giftforyou": "Hadiah untuk kamu",
    "page.im.setting.imForm.from": "Dari",
    "im.messageList.unknowMessage": "[Mohon untuk membuka pesan ini pada Aplikasi Lazada.]",
    "page.im.window.follow.notFollow": "Pelanggan ini belum menjadi follower kamu.",
    "page.im.window.unread": "Belum Dibaca",
    "im.messageList.view": "Lihat",
    "page.im.window.follow": "Mengikuti",
    "im.messageList.whereIsMyOrderTitle": "Riwayat Pesanan",
    "page.im.window.oversize": "Berkas terlalu besar untuk diunggah (kurang dari 50M)",
    "page.import.historyBox.col.type": "Nama File",
    "lazada_im_sticker_buybuybuy": "Beli beli beli!",
    "page.im.window.send": "Kirim",
    "page.im.window.units": "unit",
    "page.im.window.label.refresh": "Segarkan",
    "page.im.window.label.unread": "Belum Dibaca",
    "page.import.tab.history": "Riwayat Import",
    "page.import.import": "Impor",
    "page.im.window.label.productName": "Nama Produk",
    "page.im.window.label.emptyMessage": "Tidak ada pesan yang diterima.",
    "page.im.setting.assignment.subTitle": "Mohon memasukkan akun Chat Utama toko kamu. Hanya akun ini yang akan bisa melihat semua chat dari customer apabila anda memiliki beberapa akun login yang berbeda. PERHATIAN bahwa setelah akun ini dimasukkan maka tidak akan bisa diganti",
    "page.import.title": "Impor",
    "page.im.window.read": "Dibaca",
    "page.im.setting.assignment.title": "Pilih akun Chat Utama kamu",
    "page.import.historyBox.feedback.success": "Import Anda sudah selesai",
    "page.im.setting.tab2": "Balasan Cepat",
    "page.im.window.defaultText": "Jenis pesan tidak dikenal.",
    "im.messageList.reviewShippingInformationItemTip": "Total Item",
    "im.messageList.voucherBtn": "Kumpulkan",
    "im.messageList.order": "Pesanan",
    "page.im.setting.assignment.placeholder": "Email, Nama Pengguna",
    "lazada_im_sticker_peep": "Nonton secara diam diam",
    "page.im.window.filter.read": "Dibaca",
    "page.im.window.label.pending": "tertunda",
    "im.messageList.orderDate": "Tanggal Pesanan",
    "page.im.window.filter.unread": "Belum Dibaca",
    "page.im.window.translation.advertisements": "Alibaba Translation",
    "lazada_im_sticker_shoppingday": "Hari Belanja",
    "im.messageList.returnRequestTitle": "Permintaan Pengembalian",
    "page.im.window.label.orderTime": "Waktu pesanan",
    "page.im.window.label.sellerSku": "Seller SKU",
    "page.im.window.orderSearchPlaceholder": "Masukkan nomor pesanan",
    "page.import.tab.import": "Impor",
    "page.im.window.disconnection": "pemutusan jaringan",
    "page.im.window.label.loading": "Memuat",
    "page.im.window.label.total": "Total",
    "page.im.window.messageInputPlaceholder": "Ketik pesan disini, enter untuk kirim pesan",
    "page.im.window.tab.product": "Produk",
    "im.messageList.returnReason": "Alasan Pengembalian",
    "im.messageList.productTitle": "Informasi Produk",
    "page.import.footer.button.another": "Impor Lainnya",
    "page.im.window.tab.order": "Memesan",
    "page.import.importBox.importButton": "Unggah File",
    "page.im.window.follow.send": "Kirim Ajakan",
    "page.im.window.draft": "DRAF",
    "lazada_im_sticker_thankyou": "Terima Kasih",
    "page.import.importBox.infos.3": "Format sandi : UTF-8, separator : semicolon",
    "page.im.setting.btn.remove": "Hapus",
    "page.import.historyBox.col.progress": "progres",
    "page.im.setting.confirm": "Apakah Anda yakin ingin menghapus pengguna dari grup ini",
    "page.import.historyBox.col.created": "Dibuat",
    "page.im.setting.btn.addUser": "Tambahkan Pengguna",
    "page.im.setting.current.desc": "dari semua halaman yang dipilih",
    "page.im.window.label.totalItems": "Total item",
    "page.im.window.label.message": "Chat",
    "lazada_im_sticker_vouchers": "Voucher",
    "im.messageList.confirm": "Alamat Sudah Sesuai.",
    "page.im.setting.tab3": "Balasan Otomatis",
    "page.import.importBox.infos.2": "Catatan : File Excel mungkin memiliki formula atau referensi",
    "im.messageList.totalReturns": "Total Pengembalian",
    "page.im.window.label.read": "Dibaca",
    "page.im.setting.btn.selectAll": "dari semua halaman",
    "page.im.window.voucher.sendBatch.choose": "Mohon untuk memilih voucher khusus follower yang akan dikirim.",
    "page.im.window.label.totalReturns": "Total returns",
    "lazada_im_sticker_like": "Suka",
    "im.messageList.followTitle": "Ikuti Toko Kami",
    "page.im.window.voucher.sendBatch.createButton": "Buat voucher baru",
    "lazada_im_sticker_ok": "OK",
    "page.im.setting.tab1": "Manajemen Pengguna",
    "page.im.window.view": "Lihat",
    "im.messageList.lazMall": "LazMall",
    "im.messageList.unpaidOrderTitle": "Pengingat Pesanan Belum Bayar",
    "page.im.window.prdSearchPlaceholder": "Masukkan judul produk",
    "page.im.setting.title": "Pengaturan Chat",
    "page.import.historyBox.col.user": "Pengguna",
    "page.im.window.label.order": "Pesanan",
    "im.messageList.reviewShippingInformationAddress": "Alamat Pengiriman",
    "page.im.window.voucher.sendBatch.creatingTitle": "Buat Voucher Baru",
    "page.im.window.voucher.sendBatch.submitError": "Voucher khusus follower gagal terkirim. Mohon coba lagi",
    "page.im.window.discount.cashLabelPrefixLine2": "Uang",
    "page.import.historyBox.link.download": "Unduh",
    "page.im.setting.management.title": "Dukungan Pelanggan",
    "page.im.window.discount.rateLabel": "%",
    "page.import.tab.template": "Riwayat Template",
    "page.im.window.discount.cashLabelSuffix": "Potongan",
    "page.im.window.voucher.sendBatch.errorTip": "Sistem bermasalah :(",
    "page.im.window.get": "Dapatkan",
    "page.im.window.voucher.sendBatch.desc": "Kamu akan mengirim voucher khusus follower ke follower toko.",
    "page.im.window.voucher.sendBatch.title": "Kirim Voucher Massal ke Follower",
    "page.im.window.label.all": "Semua",
    "page.im.window.voucher.sendBatch.creatingButton": "Buat voucher baru",
    "im.messageList.reviewShippingInformationTitle": "Cek Alamat Pengiriman",
    "lazada_im_sticker_kisses": "Ciuman",
    "page.im.window.process.resend": "Kirim ulang"
};